import { Paperclip } from "lucide-react";

import RichTextEditor from "../../../components/RichTextEditor";
import { Button } from "../../../components/ui/button";
import {
  DELETABLE_TICKET_STATUSES,
  MAX_TICKET_ATTACHMENTS,
  STATUS_OPTIONS,
} from "../constants";

export default function TicketManagement({
  activeDevelopers,
  adminComment,
  adminStatus,
  developmentTimeMinutes,
  loading,
  messageFiles,
  onAssignmentChange,
  onCommentChange,
  onDelete,
  onDevelopmentTimeChange,
  onFilesChange,
  onStatusChange,
  onSubmit,
  ticket,
  userRole,
}) {
  const canManageTicket = userRole === "admin" || userRole === "developer";

  return (
    <>
      {userRole === "admin" && (
        <div className="support-admin-box">
          <h3 className="heading-3">Affectation développeur</h3>
          <select
            className="form-input"
            value={ticket.assigned_developer_id || ""}
            onChange={(event) => onAssignmentChange(event.target.value)}
            disabled={loading}
          >
            <option value="">Aucun développeur</option>
            {activeDevelopers.map((developer) => (
              <option key={developer.id} value={developer.id}>{developer.full_name}</option>
            ))}
          </select>
          <p className="body-small">Le développeur attribué reçoit un email et verra ce ticket dans son espace.</p>
        </div>
      )}

      {userRole === "admin" && DELETABLE_TICKET_STATUSES.includes(ticket.status) && (
        <div className="support-admin-box">
          <h3 className="heading-3">Suppression du ticket</h3>
          <p className="body-small">
            La suppression est disponible uniquement quand le ticket est ouvert ou en cours de traitement.
          </p>
          <Button
            type="button"
            className="btn-secondary support-danger-btn"
            onClick={onDelete}
            disabled={loading}
          >
            Supprimer le ticket
          </Button>
        </div>
      )}

      {canManageTicket && (
        <form onSubmit={onSubmit} className="support-admin-box">
          <h3 className="heading-3">Repondre et piloter le ticket</h3>
          <p className="body-small">
            Tu peux envoyer un message sans changer le statut, changer seulement le statut, ou faire les deux.
          </p>
          <select className="form-input" value={adminStatus} onChange={(event) => onStatusChange(event.target.value)}>
            {STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
          <input
            className="form-input"
            type="number"
            min="0"
            step="1"
            placeholder="Temps passe en minutes"
            value={developmentTimeMinutes}
            onChange={(event) => onDevelopmentTimeChange(event.target.value)}
          />
          <RichTextEditor
            value={adminComment}
            onChange={onCommentChange}
            placeholder="Message visible par le client, avec mise en forme si besoin"
            minHeight={150}
          />
          <label className="support-message-file-picker">
            <Paperclip aria-hidden="true" />
        <span>Ajouter des pièces jointes</span>
            <input
              key={messageFiles.length}
              type="file"
              multiple
              accept=".pdf,.png,.jpg,.jpeg,.docx"
              onChange={onFilesChange}
            />
          </label>
          <div className="support-message-file-summary">
            <span>
              {messageFiles.length > 0
                ? `${messageFiles.length} fichier(s) selectionne(s)`
                : `Jusqu'a ${MAX_TICKET_ATTACHMENTS} fichiers, 5 Mo maximum par fichier`}
            </span>
            {messageFiles.map((file) => (
              <small key={`${file.name}-${file.size}`}>{file.name}</small>
            ))}
          </div>
          <Button type="submit" className="btn-primary" disabled={loading}>Enregistrer l'action</Button>
        </form>
      )}
    </>
  );
}
